/* src/app/hire-person-search/add-to-pipeline-stage/add-to-pipeline-stage.component.scss */
.custom-dropdown-menu {
  position: absolute;
  z-index: 1;
  background: #fff;
  border-radius: 8px;
  min-width: 220px;
  width: 100%;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transform: translate3d(-75px, 0px, 10px);
}
.custom-dropdown-menu .custom-dropdown-search {
  position: relative;
  padding: 8px;
  border-bottom: 1px solid #f0f0f0;
}
.custom-dropdown-menu .custom-dropdown-search .search-icon {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: #999;
  font-size: 12px;
}
.custom-dropdown-menu .custom-dropdown-search .search-input {
  width: 100%;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 4px 8px 4px 28px;
  font-size: 12px;
  outline: none;
}
.custom-dropdown-menu .custom-dropdown-search .search-input:focus {
  border-color: #2e93a1;
}
.custom-dropdown-menu .custom-dropdown-list {
  list-style: none;
  padding: 0;
  margin: 0;
  max-height: 200px;
  overflow-y: auto;
}
.custom-dropdown-menu .custom-dropdown-list .custom-dropdown-item {
  padding: 8px 16px;
  font-size: 14px;
  cursor: pointer;
  color: #484B59;
}
.custom-dropdown-menu .custom-dropdown-list .custom-dropdown-item:hover,
.custom-dropdown-menu .custom-dropdown-list .custom-dropdown-item.active {
  background: rgba(46, 147, 161, 0.08);
  color: #2e93a1;
}
.custom-dropdown-menu .custom-dropdown-list .custom-dropdown-item.no-results {
  color: #999;
  cursor: default;
  text-align: center;
}
.custom-dropdown-menu .custom-dropdown-footer {
  padding: 8px 16px;
  border-top: 1px solid #f0f0f0;
  font-size: 14px;
  color: #2e93a1;
  cursor: pointer;
  font-weight: 500;
}
.custom-dropdown-menu .custom-dropdown-footer:hover {
  background: rgba(46, 147, 161, 0.08);
}
.ats-dropBtn button {
  padding: 0;
  border: none;
  color: #969696;
  outline: none;
  background-color: #fff;
}
.ats-dropBtn button.dropdown-toggle::after {
  display: none;
}
.ats-dropBtn .dropdown-menu.show {
  left: -125px !important;
  transform: translate3d(-33px, 17px, 0px) !important;
  padding: 0;
  overflow: hidden;
}
.ats-dropBtn .dropdown-menu.show .dropdown-item {
  padding: 0.75rem 0.75rem;
}
.ats-dropBtn .dropdown-menu.show .dropdown-item:hover {
  background-color: #E4F1F3;
}
.add-to button.btn-trms-light {
  background-color: #F4F4F4;
  color: #484b59;
  font-size: 12px;
  height: auto;
}
.add-to .dropdown-menu.show {
  top: 40px;
  left: -55px;
  width: 220px;
  height: 160px;
  overflow-y: auto;
  border-radius: 4px;
  border: 1px solid #F5F5F5;
  background: #FFF;
  box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;
  font-size: 12px;
}
.add-to .dropdown-menu.show .dropdown-item {
  padding: 8px 10px;
}
.add-to .dropdown-menu.show .dropdown-item:hover {
  background-color: #F4F9FA;
  color: #2E93A1 !important;
}
.add-to .dropdown-menu.show .optionheader {
  padding: 10px;
  position: relative;
  color: #969696;
}
.add-to .dropdown-menu.show .optionheader::after {
  position: absolute;
  display: block;
  content: "";
  width: 25%;
  height: 2px;
  background-color: #F2F2F2;
  right: 10px;
  top: 16px;
}
.add-to .dropdown-menu.show::-webkit-scrollbar {
  width: 3px !important;
}
.add-to .dropdown-menu.show::-webkit-scrollbar-track {
  background: #F2F2F2 !important;
}
.add-to .dropdown-menu.show::-webkit-scrollbar-thumb {
  background: #D9D9D9 !important;
}
.add-to .dropdown-menu.show::-webkit-scrollbar-thumb:hover {
  background: #555 !important;
}
::ng-deep .button-place .modal-content {
  position: relative;
}
::ng-deep .button-place .btn-trms-small {
  position: absolute;
  bottom: 0;
  right: 0;
  transform: translate(0px, 50px);
}
::ng-deep .button-place .btn-trms-gray {
  position: absolute;
  bottom: 0;
  right: 0;
  transform: translate(-130px, 50px);
}
::ng-deep .button-place .btn-trms-white {
  position: absolute;
  bottom: 0;
  right: 0;
  transform: translate(0px, 50px);
}
::ng-deep .button-place .modal-dialog,
::ng-deep .button-place .modal-content {
  overflow: visible;
}
/*# sourceMappingURL=add-to-pipeline-stage.component-U7DLSH72.css.map */
